<script setup lang="ts">
const model = defineModel<boolean>({ default: false })

withDefaults(
  defineProps<{
    id: string
    label: string
    description?: string
    disabled?: boolean
  }>(),
  {
    description: "",
    disabled: false,
  }
)
</script>

<template>
  <label :for="id" class="flex items-start gap-3 rounded-md border border-slate-200 p-3">
    <input :id="id" v-model="model" :disabled="disabled" type="checkbox" class="mt-0.5 size-4 rounded border-slate-300" />

    <span>
      <span class="block text-sm font-medium text-slate-800">{{ label }}</span>
      <span v-if="description" class="block text-xs text-slate-500">{{ description }}</span>
    </span>
  </label>
</template>

